export const Tasks = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 146.286V0H1024V146.286H0ZM1024 438.857H0V292.571H1024V438.857ZM0 731.429H1024V585.143H0V731.429ZM1024 1024H0V877.714H1024V1024Z"/>
`;






// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/tasks.js